import { useState } from "react";
import { supabase } from "../supabaseClient";

const GOLD     = "#C9A96E";
const TAUPE    = "#B5B0A8";
const INK      = "#1C1915";
const INK_SOFT = "#4A4540";
const BORDER   = "#E7E1D8";
const SOFT_BG  = "#F7F5F2";
const WHITE    = "#FFFFFF";

export default function LoginPage({ onLogin }) {
  const [email,    setEmail]    = useState("");
  const [password, setPassword] = useState("");
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState("");

  async function handleLogin() {
    if (!email.trim() || !password.trim()) {
      setError("Merci de renseigner votre email et mot de passe.");
      return;
    }

    setLoading(true);
    setError("");

    const { data, error: authError } = await supabase.auth.signInWithPassword({
      email: email.trim(),
      password,
    });

    if (authError) {
      setError("Email ou mot de passe incorrect.");
      setLoading(false);
      return;
    }

    // Récupère le profil et le rôle
    const { data: profile, error: profileError } = await supabase
      .from("profiles")
      .select("*")
      .eq("id", data.user.id)
      .single();

    if (profileError || !profile) {
      setError("Impossible de récupérer votre profil. Contactez l'administrateur.");
      setLoading(false);
      return;
    }

    onLogin(profile);
    setLoading(false);
  }

  function handleKeyDown(e) {
    if (e.key === "Enter") handleLogin();
  }

  const inputStyle = {
    width: "100%", padding: "12px 16px",
    border: `1px solid ${BORDER}`, borderRadius: 8,
    fontSize: 14, color: INK, background: SOFT_BG,
    outline: "none", boxSizing: "border-box",
    transition: "border-color 0.2s",
  };

  return (
    <div style={{
      minHeight: "100vh", background: TAUPE,
      display: "flex", alignItems: "center", justifyContent: "center",
      fontFamily: "system-ui, -apple-system, sans-serif",
    }}>

      {/* Carte centrale */}
      <div style={{
        background: WHITE, borderRadius: 16,
        padding: "48px 44px", width: 420,
        boxShadow: "0 24px 64px rgba(0,0,0,0.12)",
      }}>

        {/* Logo */}
        <div style={{ marginBottom: 36, textAlign: "center" }}><div style={{
            fontSize: 28, fontWeight: 800, color: INK,
            letterSpacing: "0.1em", marginBottom: 4,
          }}>
            YOMA
          </div><div style={{
            fontSize: 10, letterSpacing: "0.18em",
            textTransform: "uppercase", color: TAUPE,
          }}>
            Coordination · Pilotage · Mandat
          </div><div style={{
            width: 32, height: 2, background: GOLD,
            margin: "14px auto 0",
          }} /></div>

        {/* Titre */}
        <div style={{ marginBottom: 28 }}><div style={{ fontSize: 18, fontWeight: 700, color: INK, marginBottom: 4 }}>
            Connexion
          </div><div style={{ fontSize: 13, color: INK_SOFT }}>
            Accédez à votre espace de travail
          </div></div>

        {/* Champs */}
        <div style={{ marginBottom: 16 }}><label style={{
            display: "block", fontSize: 10, letterSpacing: "0.12em",
            textTransform: "uppercase", color: INK_SOFT,
            fontWeight: 600, marginBottom: 6,
          }}>
            Adresse email
          </label><input
            style={inputStyle}
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="votre@email.com"
            autoFocus
          /></div><div style={{ marginBottom: 24 }}><label style={{
            display: "block", fontSize: 10, letterSpacing: "0.12em",
            textTransform: "uppercase", color: INK_SOFT,
            fontWeight: 600, marginBottom: 6,
          }}>
            Mot de passe
          </label><input
            style={inputStyle}
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="••••••••"
          /></div>

        {/* Erreur */}
        {error && (
          <div style={{
            padding: "10px 14px", background: "#FDEDEC",
            border: "1px solid #F5B7B1", borderRadius: 8,
            fontSize: 12, color: "#C0392B", marginBottom: 20,
          }}>
             {error}
          </div>
        )}

        {/* Bouton */}
        <button
          onClick={handleLogin}
          disabled={loading}
          style={{
            width: "100%", padding: "13px 0",
            background: loading ? TAUPE : GOLD,
            color: WHITE, border: "none", borderRadius: 9,
            fontSize: 14, fontWeight: 700, cursor: loading ? "not-allowed" : "pointer",
            letterSpacing: "0.06em", transition: "background 0.2s",
          }}
        >
          {loading ? "Connexion en cours…" : "Se connecter"}
        </button>

        {/* Footer */}
        <div style={{
          marginTop: 24, textAlign: "center",
          fontSize: 11, color: TAUPE, lineHeight: 1.6,
        }}>
          Accès réservé aux collaborateurs YOMA.<br />
          Contactez l'administrateur pour obtenir un accès.
        </div></div></div>
  );
}
